import {
  ACTIVITY_CONNECTIONS_UPDATED_EVENT_TYPE,
  ACTIVITY_UPDATED_EVENT_TYPE,
  useHistoryTabEvents
} from "./use_history_tab_events";

export const useAvailableEventTypes = (): string[] => {
  const { data: historyData } = useHistoryTabEvents();
  const availableEventTypes = historyData?.meta.availableEventTypes ?? [];

  const hasActivityUpdated = availableEventTypes.some(
    (type) => type === ACTIVITY_UPDATED_EVENT_TYPE || type === ACTIVITY_CONNECTIONS_UPDATED_EVENT_TYPE
  );
  const otherEventTypes = availableEventTypes.filter(
    (type) => type !== ACTIVITY_UPDATED_EVENT_TYPE && type !== ACTIVITY_CONNECTIONS_UPDATED_EVENT_TYPE
  );

  // Product decision to merge `activity_connections_updated` with `activity_updated`
  return hasActivityUpdated ? [ACTIVITY_UPDATED_EVENT_TYPE, ...otherEventTypes] : otherEventTypes;
};
